var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM19.2095 13.704V25.32C19.2095 26.328 20.0255 27.144 21.0335 27.144C22.0415 27.144 22.8575 26.328 22.8575 25.32V11.784C22.8575 10.776 22.0415 9.96 21.0335 9.96H20.9855C20.4815 9.96 19.9535 10.08 19.2575 10.272L16.8815 10.968C16.1375 11.184 15.6575 11.808 15.6575 12.552C15.6575 13.416 16.4015 14.136 17.2655 14.136C17.4575 14.136 17.7215 14.088 17.9135 14.04L19.2095 13.704Z",
    fill: "#4A22D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/Step1.111caaa14f9a4ebc6239dc910b95a5b2.svg";
export { ForwardRef as ReactComponent };